import { filter } from 'lodash'
import { VIEW_CLIENT, VIEW_ADMIN, TIPO_USUARIO } from 'utils/constantes'

export const getUsuarios = (state) => filter(state.usuarios.lista, (usuario) => (
  VIEW_CLIENT.includes(usuario.tipoUsuario.id)
))
export const getIsCarregandoListaUsuarios = (state) => state.usuarios.isCarregandoLista
export const getUsuarioSelecionado = (state) => state.usuarios.selecionado
export const getIsCarregandoUsuario = (state) => state.usuarios.isCarregandoUsuario
// Gerente de Crédito (usuário interno LIFE, sem empresa) é listado junto dos usuários LIFE.
export const getUsuariosLife = (state) => filter(state.usuarios.lista, (usuario) => (
  VIEW_ADMIN.includes(usuario.tipoUsuario.id) || usuario.tipoUsuario.id === TIPO_USUARIO.CLIENTE.GERENTE_CREDITO
))
